import request from 'superagent'
import moment from 'moment'
const calendarID=window.calEnv.calendarID;
const max_bookings=window.calEnv.max_bookings;
const site_name=window.calEnv.site_name;

const start_date=window.calEnv.start_date;
const end_date=window.calEnv.end_date;



//const CALENDAR_ID = '3jn193v8n9ctj1elcbta79dde4@group.calendar.google.com'
//const API_KEY = 'AIzaSyDEQ6aJN0fIA9KZgbOaS37hh-mL-PbStXs'
//let url = `https://www.googleapis.com/calendar/v3/calendars/${CALENDAR_ID}/events?key=${API_KEY}`
let url = '/wp-content/plugins/tvacs-cal/php-backend/gcal_json_output.php?calendarID=' + calendarID + '&max_bookings=' + max_bookings + '&site_name=' + site_name + '&start_date=' + start_date + '&end_date=' + end_date
export function getEvents (callback) {
  request
    .get(url)
    .end((err, resp) => {
      if (!err) {
        const events = []
        JSON.parse(resp.text).items.map((event) => {
          events.push({
            start: moment(event.start.date) || moment(event.start.dateTime),
            end: moment(event.end.date) || moment(event.end.dateTime),
            title: event.summary,
            colour: event.colour
          })
        })
        callback(events)
      }
    })
}
